import React, { useState } from "react";
import menu from "../../assets/img/icons/menu.svg";
import apartment from "../../assets/img/icons/buildings.svg";
import villa from "../../assets/img/icons/house-2.svg";
import village from "../../assets/img/icons/house.svg";
import hotel from "../../assets/img/icons/buliding.svg";
import Button from "../shared/Button";
import { createSearchParams, useNavigate } from "react-router-dom";
import { useUserInfo } from "../../context/UserContext";
import { useAuth } from "../../context/authContext";
import HamberburgerMenu from "./HamberburgerMenu";

const Submenu = () => {
  const menuItems = [
    {
      link: "",
      title: "آپارتمان",
      icon: apartment,
      type: ["hotel_apartment","apartment"]
    },
    {
      link: "",
      title: "ویلا و باغ",
      icon: villa,
      type: ["villa","villa_house","villa_garden","villa_suite","suite"]
    },
    {
      link: "",
      title: "خانه روستایی",
      icon: village,
      type: ["wooden_cottage","country_house","eco_resort"]
    },
    {
      link: "",
      title: "هتل و مهمان پذیر",
      icon: hotel,
      type: ["hotel","boarding_house","boutique_hotel","guest_house","caravanserai","hotel_apartment"]
    }
  ];
  const {userinfo} = useUserInfo()
  const {token} = useAuth()
  const navigate = useNavigate();
  const goToCreate = () =>{
    if(token){
      
        if(userinfo.data.user.role === "ادمین" || userinfo.data.user.role === "میزبان" || userinfo.data.user.role === "سوپر ادمین" ){
          navigate("/create")} else {
          navigate("/hosting")
    
        }
      
      
    }else{
      navigate("/register")
    }
  }
  
  const gotocat = newtype => {
    console.log(newtype.map(i => i).toString().replace(/,/g ,"-"))
     navigate({
       pathname: "/categories",
       search: createSearchParams({
         type:  newtype.map(i => i).toString().replace(/,/g, "-")
       }).toString()
     });
  };
  const [close, setclose] = useState(false)
  return (
    <div className="Submenu">
 <HamberburgerMenu setclose={setclose} close={close}/>
      <div className="container">
        <hr className="mt-[17px] mb-[37px]" />
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div onClick={()=>setclose(true)} className="flex items-center  ml-[34px] cursor-pointer ">
              <img src={menu} className="ml-[10px]" />
              <div className="text-[#12171C] text-[20px]">منو وبسایت</div>
            </div>
            {menuItems.map(i =>
              <div
                className="flex items-center ml-[34px]  cursor-pointer"
                onClick={() => gotocat(i.type)}
              >
                <img src={i.icon} className="ml-[10px]" />
                <div className="text-[#797D82] text-[20px]">
                  {" "}{i.title}
                </div>
              </div>
            )}
          </div>
          <Button onClick={goToCreate} varient="primary" >
            افزودن اقامتگاه
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Submenu;
